<template lang="pug">
  div.wrap-module-tutorial-welcome
    div.py40
      div.f.fc.mb24
        span.block.bold あなたのことや習慣についてお聞かせください。
      div.wrap-questions.pb40
        ItemCouncelingRadio(ref="sex"
          :defaultAnswer="sex"
          question="性別"
          :selection="['男性', '女性', 'その他']")
        ItemCouncelingRadio(ref="ageGroup"
          :defaultAnswer="ageGroup"
          question="年齢"
          :selection="[10, 20, 30, 40, 50, 60, 70]"
          selectionUnit="代")
        ItemCouncelingRadio(ref="exerciseNumInWeek"
          :defaultAnswer="exerciseNumInWeek"
          question="週に何回ほど運動を行いますか？"
          :selection="[0, 1, 2, 3, 4, 5, 6, 7]"
          selectionUnit="回"
          lastSelectionUnit="以上")
        ItemCouncelingRadio(ref="liveTrainingNumInWeek"
          :defaultAnswer="liveTrainingNumInWeek"
          question="週に何回ほどのライブフィットネスを希望しますか？"
          :selection="[1, 2, 3, 4]"
          selectionUnit="回"
          lastSelectionUnit="以上")
        //- ItemCouncelingCheckbox(ref="focusedPoints"
          :defaultAnswer="focusedPoints"
          question="気になる部位を選択してください"
          :selection="['首', '肩', '腰', '足', '腕']")
        ItemCouncelingCheckbox(ref="painfulPoints"
          :defaultAnswer="painfulPoints"
          question="痛みを伴う部位を選択してください"
          :selection="['首', '肩', '腰', '足', '腕', 'その他']")
        ItemCouncelingCheckbox(ref="purposes"
          :defaultAnswer="purposes"
          question="Habit5%の利用目的を教えてください"
          :selection="['習慣化', '減量', 'シェイプアップ', '筋力アップ', 'パフォーマンスアップ']")
        //- v-radio-group(v-model="exerciseNumInWeek")
        //-   p.block.bold.fz12 週に何回ほど運動を行いますか？
        //-   div.f.flex-wrap
        //-     v-radio(v-for="n in [0, 1, 2, 3, 4, 5, 6, 7]"
        //-       :label="(n != 7) ? `${n}回` : `毎日`"
        //-       :value="n").mr8.mb8
        //- v-radio-group(v-model="liveTrainingNumInWeek")
        //-   p.block.bold.fz12 週に何回ほどのライブフィットネスを希望しますか？
        //-   div.f.flex-wrap
        //-     v-radio(v-for="n in [1, 2, 3, 4]"
        //-       :label="(n != 4) ? `${n}回` : `4回以上`"
        //-       :value="n").mr8.mb8
</template>

<style lang="scss" scoped>
.wrap-module-tutorial-welcome {
  width: 100%;
  min-height: 100vh;
  .wrap-questions {
    margin: 0 auto;
    width: 93%;
    max-width: 820px;
  }
}
</style>

<style lang="scss">
.wrap-module-tutorial-welcome {
  .v-input--selection-controls {
    margin: 0 !important;
  }
  .v-input--selection-controls__input {
    margin-right: 4px !important;
  }
}
</style>

<script>
import db from "@/components/utils/firebase"
import { createNamespacedHelpers } from "vuex"
const { mapState: mapStateAuth } = createNamespacedHelpers("auth")
import ItemCouncelingRadio from "@/components/item/ItemCouncelingRadio"
import ItemCouncelingCheckbox from "@/components/item/ItemCouncelingCheckbox"

export default {
  components: {
    ItemCouncelingRadio,
    ItemCouncelingCheckbox
  },
  computed: {
    ...mapStateAuth(["uid"])
  },
  data () {
    return {
      sex: "男性",
      ageGroup: 30,
      exerciseNumInWeek: 1,
      liveTrainingNumInWeek: 1,
      focusedPoints: [],
      painfulPoints: [],
      purposes: []
    }
  },
  async created () {
    let tutorialDoc = await db.collection("TRAINEE")
        .doc(this.uid).collection("COUNSELING")
        .doc("TUTORIAL").get().then(d => { return d })
    if (tutorialDoc.exists) {
      let tutorial = tutorialDoc.data()
      this.sex = tutorial.body.sex
      this.ageGroup = tutorial.body.ageGroup
      this.exerciseNumInWeek = tutorial.body.exerciseNumInWeek
      this.liveTrainingNumInWeek = tutorial.body.liveTrainingNumInWeek
      // this.focusedPoints = tutorial.body.focusedPoints
      this.painfulPoints = tutorial.body.painfulPoints
      this.purposes = tutorial.body.purposes
    }
  },
  methods: {
    async save () {
      let tutorialObj = {
        body: {
          sex: this.$refs.sex.getAnswer(),
          ageGroup: this.$refs.ageGroup.getAnswer(),
          exerciseNumInWeek: this.$refs.exerciseNumInWeek.getAnswer(),
          liveTrainingNumInWeek: this.$refs.liveTrainingNumInWeek.getAnswer(),
          // focusedPoints: this.$refs.focusedPoints.getAnswer(),
          painfulPoints: this.$refs.painfulPoints.getAnswer(),
          purposes: this.$refs.purposes.getAnswer()
        },
        created: new Date()
      }
      
      await db.collection("TRAINEE")
        .doc(this.uid).collection("COUNSELING")
        .doc("TUTORIAL").set(tutorialObj)
    }
  }
}
</script>
